module.exports = __webpack_public_path__ + "static/media/03.083bb483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/03.jpg
// module id = 693
// module chunks = 0